require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./die-ferien-sind-vorbei.json") })
        }
      }, "path---die-ferien-sind-vorbei");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---die-ferien-sind-vorbei!./.cache/json/die-ferien-sind-vorbei.json
// module id = 416
// module chunks = 231608221292675